/* Yenilikler: the Turkish release notes from CHANGELOG.md, newest first, with the running version marked. */
import { APP_VERSION, RELEASES } from '../../content/changelog';
import { fmtDate } from '../../core/util';
import { Icon } from '../../ui/icons';
import { Rich } from '../../ui/Rich';
import { vars } from '../../ui/style';

export function ChangelogPage() {
  return (
    <div style={vars({ '--mod': 'var(--accent)' })}>
      <header className="mod-head" style={{ marginBottom: '22px' }}>
        <div className="mod-icon">
          <Icon name="spark" />
        </div>
        <div className="mod-titles">
          <h1>Yenilikler</h1>
          <p>
            Her sürümde neyin değiştiği, en yenisi en üstte. Şu an <strong>{APP_VERSION}</strong> sürümünü
            kullanıyorsun.
          </p>
        </div>
      </header>
      <div className="releases">
        {RELEASES.length ? null : <p className="empty">Henüz sürüm notu yok.</p>}
        {RELEASES.map((r) => {
          const current = r.version === APP_VERSION;
          return (
            <section key={r.version} className={`release${current ? ' current' : ''}`}>
              <div className="rel-head">
                <h2>Sürüm {r.version}</h2>
                {current ? <span className="rel-tag">Güncel</span> : null}
                {r.date ? (
                  <time className="rel-date" dateTime={r.date}>
                    {fmtDate(r.date)}
                  </time>
                ) : null}
              </div>
              <ul className="rel-notes">
                {r.notes.map((n) => (
                  <li key={n.tr}>
                    <Rich text={n.tr} />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
